import React from 'react';

import { AccentBadge } from './accent-badge';
import { IBadgeProps } from './types';

const Badge = AccentBadge.withConfig({
  backgroundColor: 'transparent',
  padding: 0,
  marginTop: '1',
  marginX: 0,
  marginBottom: 0,
});

export const LoginRequiredBadge: React.FC<React.PropsWithChildren<IBadgeProps>> = ({
  formatMessage,
}) => <Badge testID="login-required-badge">{formatMessage({ id: 'signUpToRedeem' })}</Badge>;
